"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var select_url_variable_component_1 = __importDefault(require("./select-url-variable.component"));

var SelectUrlVariableContainer = function SelectUrlVariableContainer(_ref) {
  var handleSelectVariable = _ref.handleSelectVariable;
  var urlVariables = react_redux_1.useSelector(scenario_selectors_1.selectUrlVariables);
  return react_1.default.createElement(select_url_variable_component_1.default, {
    urlVariables: urlVariables,
    handleSelectVariable: handleSelectVariable
  });
};

exports.default = SelectUrlVariableContainer;